import axios from '@/axios'

export default {
  getAll() {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/recommended-items`)
        .then(response => {
          return resolve(response.data)
        })
        .catch(error => {
          return reject(error.response)
        })
    })
  },
  getByUserId(id) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/recommended-items/user/${id}`)
        .then(response => {
          return resolve(response.data)
        })
        .catch(error => {
          return reject(error.response)
        })
    })
  },
  add(item) {
    return new Promise((resolve, reject) => {
      axios
        .post(`/api/admin/recommended-items`, item)
        .then(response => {
          return resolve(response.data)
        })
        .catch(error => {
          return reject(error.response)
        })
    })
  },
  adminAdd(item) {
    return new Promise((resolve, reject) => {
      axios
        .post(`/api/admin/recommended-items`, item)
        .then(response => {
          return resolve(response.data)
        })
        .catch(error => {
          return reject(error.response)
        })
    })
  },
  update(item) {
    return new Promise((resolve, reject) => {
      axios
        .put(`/api/admin/recommended-items`, item)
        .then(response => {
          return resolve(response.data)
        })
        .catch(error => {
          return reject(error.response)
        })
    })
  },
  remove(item) {
    return new Promise((resolve, reject) => {
      axios
        .delete(`/api/admin/recommended-items/${item.itemId}`)
        .then(response => {
          return resolve(response.data)
        })
        .catch(error => {
          return reject(error.response)
        })
    })
  }
}
